import 'slick-carousel/slick/slick';

const servicesStep = () => {
  jQuery(document).ready(function () {
    //
    var windowWidth = jQuery(window).width(); // to hide slider

    if (windowWidth > 1140) {
      jQuery('#section4').css({
        'display': 'none'
      });
    } else {
      jQuery('#section4').css({
        'display': ''
      });
      jQuery('#section3').css({
        'display': 'none'
      });
    }

    jQuery(window).on('resize', function () {
      var win = jQuery(this); //this = window

      if (win.width() > 1140) {
        jQuery('#section4').css({
          'display': 'none'
        });
        jQuery('#section3').css({
          'display': ''
        });
      } else {
        jQuery('#section4').css({
          'display': ''
        });
        jQuery('#section3').css({
          'display': 'none'
        });
      }
    });
    jQuery('.clickable-row').each(function (idx, el) {
      // attach on click
      jQuery(el).on('click', function () {
        var $this = jQuery(this);
        var selectedId = $this.data('row-id');
        var $closestParent = $this.closest('.step-title-container');
        var $imageContainer = $closestParent.siblings('.step-image-container'); // toggle selected

        $closestParent.find('.clickable-row').removeClass('selected').addClass('not-selected');
        $closestParent.find('.step-arrow').removeClass('active').addClass('hide'); // set selected as selected

        if ($this.hasClass('not-selected')) {
          $this.removeClass('not-selected').addClass('selected'); // activate arrow

          $this.find('.step-arrow').removeClass('hide').addClass('active');
        } // find all image and display


        $imageContainer.find('img[class^=img-id]').removeClass('active').addClass('hide'); // activate specific image

        $imageContainer.find('.img-id-' + selectedId).removeClass('hide').addClass('active');
      });
    }); //

    jQuery('.step-slider-container.mobile > .for-slider').each(function (num, elem) {
      var $elem = jQuery(elem);
      $elem.slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [{
          breakpoint: 1140,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    });
  });
};

export default servicesStep;